import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { FontWeight, IconButton, Fonts, Button } from "@snapchat/snap-design-system";
import { Flexbox } from "../../../core/components";

export const InputContainer = styled.div`
    padding: 0;
    border-bottom: "none";
`;

export const newGroupButtonOverrides = css`
    padding-left: 0 !important;
`;

export const AddIconContainer = styled.div`
    margin-right: 8px;
`;

export const AddLensGroupButton = styled(Flexbox)`
    cursor: pointer;
    height: 40px;
    padding: 8px 0;
    font-size: 16px;
`;

export const SpinnerContainer = styled.div<{ show: boolean }>`
    position: relative;
    display: ${({ show }) => (show ? "block" : "none")};
    height: 40px;
    padding: 8px 0;
`;

export const CreateButton = styled(Button)`
    position: absolute;
    z-index: 2;
    top: 20px;
    right: 0;
    transform: translateY(-50%);

    &.sds-base-button.ant-btn {
        margin-right: 26px;
        padding: 10px;
        font-weight: ${FontWeight.NORMAL};
    }
`;

export const ResetIconContiner = styled.div`
    pointer-events: none;
    cursor: pointer;

    position: absolute;
    z-index: 2;
    top: 20px;
    left: 16px;
    transform: translateY(-50%);
`;

export const NewGroupNameLabel = styled.span`
    ${Fonts.Control.Input}
    font-family: Arial, Helvetica, sans-serif;
    visibility: hidden;
`;

export const ResetButton = styled(IconButton)`
    pointer-events: all;

    &.sds-base-button.ant-btn {
        padding: 10px;
    }
`;
